import {
    get_headers
} from '@/utils/constants/constants.js';
import {
    CREATE_APPLICATION_TRANSITION_RULES,
    GET_ALL_TRANSITION_TYPES,
    GET_FORM_WORKFLOW_TRANSITION_RULES,
    UPDATE_TRANSITION_RULE,
    DELETE_TRANSITION_RULE,
} from '@/utils/constants/constants.js';
import axios from 'axios';

export const transition_rules_mixin = {
    data: () => ({
        editing_rule: null,
        editing_status_index: null,
        editing_reviewer_index: null,
        deleting_rule_id: null,
        deleting_status_index: null,
        transition_types: [],
        loading_transition_types: false,
        headers: get_headers(),
        selected_section_for_questions: "",
        selected_questions: [],
    }),

    methods: {
        initialize_reviewer: () => {
            const reviewer = {
                role: '',
                show_condition_ui: false,
                selected_match_requirement: 'All conditions',
                conditions: [],
                assigned_users: [],
                selected_role: null,
                role_name: null,
                available_users: [],
                selected_users: [],
                transition_type: 'automatic',
                show_conditions: false,
                action_section_access: {},
                workflow_reviewer_id: null,
                to_status_id: '',
                min_approvals: 1,
                match_requirement: 'all'
            };
            return reviewer;
        },

        open_edit_rule_modal(status_index, reviewer_index) {
            const workflow_statuses = Reflect.get(this, 'workflow_statuses');
            const status = Reflect.get(workflow_statuses, status_index);
            const reviewers = Reflect.get(status, 'reviewers');

            if (!reviewers || reviewers.length <= reviewer_index) {
            this.show_error('Reviewer not found');
            return;
            }

            const reviewer = Reflect.get(reviewers, reviewer_index);
            Reflect.set(this, 'editing_status_index', status_index);
            Reflect.set(this, 'editing_reviewer_index', reviewer_index);
            Reflect.set(this, 'editing_rule', JSON.parse(JSON.stringify(reviewer)));
            if (!Reflect.get(Reflect.get(this, 'editing_rule'), 'conditions')) {
            Reflect.set(Reflect.get(this, 'editing_rule'), 'conditions', []);
            }
            Reflect.set(Reflect.get(this, 'editing_rule'), 'show_condition_ui', true);
            this.initialize_transition_types();
        },

        open_delete_rule_modal(rule_id, status_index, reviewer_index) {
            Reflect.set(this, 'deleting_rule_id', rule_id);
            Reflect.set(this, 'deleting_status_index', status_index);
            Reflect.set(this, 'deleting_reviewer_index', reviewer_index);
        },

        async update_transition_rule() {
            if (!Reflect.get(this, 'editing_rule')) {
            this.show_error('No rule to update');
            return;
            }

            const status_index = Reflect.get(this, 'editing_status_index');
            const workflow_statuses = Reflect.get(this, 'workflow_statuses');
            const status = Reflect.get(workflow_statuses, status_index);
            const reviewer = Reflect.get(this, 'editing_rule');
            const conditions_payload = this.prepare_conditions_payload(reviewer);
            const validation_result = this.validate_transition_rule(reviewer, conditions_payload);

            if (!validation_result.valid) {
            this.show_error(validation_result.message);
            return;
            }

            const transition_rule = this.build_transition_rule(status, reviewer, conditions_payload);
            Reflect.set(transition_rule, 'rule_id', Reflect.get(reviewer, 'id'));
            Reflect.set(transition_rule, 'from_status_id', parseInt(Reflect.get(status, 'id'), 10));
            Reflect.set(transition_rule, 'is_active', true);

            const payload = {
            form_id: parseInt(Reflect.get(this, 'form_id'), 10),
            transition_rules: [transition_rule]
            };

            try {
            const response = await axios.post(
                UPDATE_TRANSITION_RULE,
                payload,
                { headers: Reflect.get(this, 'headers') }
            );

            if (Reflect.get(Reflect.get(response, 'data'), 'status') === 'success') {
                this.show_success('Transition rule updated successfully!');

                const original_status = Reflect.get(workflow_statuses, status_index);
                const original_reviewer_index = Reflect.get(this, 'editing_reviewer_index');
                const original_reviewers = Reflect.get(original_status, 'reviewers');

                if (original_reviewers && original_reviewers.length > original_reviewer_index) {
                const original_reviewer = Reflect.get(original_reviewers, original_reviewer_index);

                Object.keys(reviewer).forEach(key => {
                    if (key !== 'conditions') {
                    Reflect.set(original_reviewer, key, Reflect.get(reviewer, key));
                    }
                });

                Reflect.set(original_reviewer, 'conditions', JSON.parse(JSON.stringify(Reflect.get(reviewer, 'conditions'))));
                Reflect.set(original_reviewer, 'show_condition_ui', false);
                }

                await this.get_transition_rules(status);
            } else {
                this.show_error('Failed to update transition rule');
            }
            } catch (error) {
            this.handle_transition_error(error);
            } finally {
            this.reset_edit_modal();
            }
        },

        async delete_transition_rule() {
            const rule_id = Reflect.get(this, 'deleting_rule_id');
            const status_index = Reflect.get(this, 'deleting_status_index');
            const reviewer_index = Reflect.get(this, 'deleting_reviewer_index');

            if (!rule_id) {
                this.show_error('No rule selected for deletion');
                return;
            }

            const payload = {
                rule_id: rule_id,
                form_id: parseInt(Reflect.get(this, 'form_id'), 10)
            };

            try {
                const response = await axios.post(
                    DELETE_TRANSITION_RULE,
                    payload,
                    { headers: Reflect.get(this, 'headers') }
                );

                if (Reflect.get(Reflect.get(response, 'data'), 'status') === 'success') {
                    this.show_success('Transition rule deleted successfully!');

                    const workflow_statuses = Reflect.get(this, 'workflow_statuses');
                    const status = Reflect.get(workflow_statuses, status_index);

                    if (Reflect.get(status, 'existing_transition_rules')) {
                        Reflect.set(status, 'existing_transition_rules',
                            Reflect.get(status, 'existing_transition_rules')
                                .filter(rule => Reflect.get(rule, 'id') !== rule_id));
                    }

                    if (Reflect.get(status, 'reviewers')) {
                        Reflect.set(status, 'reviewers',
                            Reflect.get(status, 'reviewers')
                                .filter((_, index) => index !== reviewer_index));

                        Reflect.set(status, 'reviewer_count', Reflect.get(status, 'reviewers').length);
                    }

                } else {
                    this.show_error('Failed to delete transition rule');
                }
            } catch (error) {
                this.handle_transition_error(error);
            } finally {
                Reflect.set(this, 'deleting_rule_id', null);
                Reflect.set(this, 'deleting_status_index', null);
                Reflect.set(this, 'deleting_reviewer_index', null);
            }
        },

        confirm_delete_rule(rule_id, status_index, reviewer_index) {
            this.show_confirm(
                "Delete Transition Rule",
                "Are you sure you want to delete this transition rule? This action cannot be undone.",
                () => {
                    Reflect.set(this, 'deleting_rule_id', rule_id);
                    Reflect.set(this, 'deleting_status_index', status_index);
                    Reflect.set(this, 'deleting_reviewer_index', reviewer_index);
                    this.delete_transition_rule();
                }
            );
        },

        reset_edit_modal() {
            Reflect.set(this, 'editing_rule', null);
            Reflect.set(this, 'editing_status_index', null);
            Reflect.set(this, 'editing_reviewer_index', null);
        },

        reset_delete_modal() {
            Reflect.set(this, 'deleting_rule_id', null);
            Reflect.set(this, 'deleting_status_index', null);
            Reflect.set(this, 'deleting_reviewer_index', null);
        },

        async fetch_transition_types() {
            Reflect.set(this, 'loading_transition_types', true);

            return axios.post(
                GET_ALL_TRANSITION_TYPES,
                undefined,
                { headers: { ...this.headers, 'Content-Type': 'application/json' } }
            )
                .then(response => {
                    const data = Reflect.get(response, 'data');

                    if (Reflect.get(data, 'status') === 'success') {
                        Reflect.set(this, 'transition_types', Reflect.get(data, 'data'));
                    } else {
                        this.show_error('Failed to load transition types');
                    }
                })
                .catch(error => {
                    this.show_error('Error fetching transition types: ' + error.message);
                })
                .finally(() => {
                    Reflect.set(this, 'loading_transition_types', false);
                });
        },

        initialize_transition_types() {
            if (Reflect.get(this, 'transition_types').length === 0 && !Reflect.get(this, 'loading_transition_types')) {
                this.fetch_transition_types();
            }
        },

        async save_transition_rule(reviewer, status_index) {
            const workflow_statuses = Reflect.get(this, 'workflow_statuses');
            const status = Reflect.get(workflow_statuses, status_index);
            const conditions_payload = this.prepare_conditions_payload(reviewer);
            const validation_result = this.validate_transition_rule(reviewer, conditions_payload);

            if (!validation_result.valid) {
                this.show_error(validation_result.message);
                return;
            }

            const transition_rule = this.build_transition_rule(status, reviewer, conditions_payload);
            const payload = this.build_transition_payload(transition_rule);

            try {
                const response = await axios.post(
                    CREATE_APPLICATION_TRANSITION_RULES,
                    payload,
                    { headers: Reflect.get(this, 'headers') }
                );

                if (response.data?.status === 'success') {
                    this.show_success('Transition rule saved successfully!');
                    const response_data = response.data?.data;
                    if (response_data && response_data.length > 0 && response_data[0]) {
                        const created_rule = response_data[0];
                        Reflect.set(reviewer, 'id', created_rule.id);
                        if (created_rule.workflow_reviewer_id) {
                            Reflect.set(reviewer, 'workflow_reviewer_id', created_rule.workflow_reviewer_id);
                        }
                    }

                    reviewer.show_condition_ui = false;
                    await this.get_transition_rules(status);
                } else {
                    this.show_error('Failed to save transition rule');
                }
            } catch (error) {
                this.handle_transition_error(error);
            }
        },

        validate_transition_rule(reviewer, conditions_payload) {
            const to_status_id = parseInt(Reflect.get(reviewer, 'to_status_id'), 10);
            if (isNaN(to_status_id)) {
                const invalid_status_message = { valid: false, message: 'Please select a valid target status' };
                return invalid_status_message;
            }

            const transition_type_id = parseInt(Reflect.get(reviewer, 'transition_type_id'), 10);
            if (isNaN(transition_type_id)) {
                const invalid_transition_message = { valid: false, message: 'Please select a valid transition type' };
                return invalid_transition_message;
            }

            for (let condition of conditions_payload) {
                const selected_actions = Reflect.get(condition, 'selected_actions');

                if (!selected_actions || selected_actions.length === 0) {
                    const missing_action_message = { valid: false, message: 'Please select at least one action for the condition' };
                    return missing_action_message;
                }
            }

            for (let condition of conditions_payload) {
                const condition_validation = this.validate_individual_condition(condition);
                if (!condition_validation.valid) return condition_validation;
            }

            const valid_result = { valid: true };
            return valid_result;
        },

        build_transition_rule(status, reviewer, conditions_payload) {
            const to_status_id = parseInt(Reflect.get(reviewer, 'to_status_id'), 10);
            const transition_type_id = parseInt(Reflect.get(reviewer, 'transition_type_id'), 10);
            const transition_types = Reflect.get(this, 'transition_types');
            const selected_transition_type = transition_types.find(type => Reflect.get(type, 'id') === transition_type_id);
            const transition_type_name = selected_transition_type ? Reflect.get(selected_transition_type, 'name') : '';

            let action_name = '';
            if (conditions_payload.length > 0) {
                const first_condition = conditions_payload[0];
                const selected_actions = Reflect.get(first_condition, 'selected_actions');
                if (selected_actions && selected_actions.length > 0) {
                    const action_names = this.get_action_names_by_ids(selected_actions);
                    action_name = action_names.join(', ');
                } else {
                    action_name = Reflect.get(first_condition, 'action') || 'section_completion';
                }
            }

            const transition_rule = {
                form_status: Reflect.get(status, 'status'),
                from_status_id: Reflect.get(status, 'id'),
                to_status: this.get_status_name(Reflect.get(reviewer, 'to_status_id')),
                to_status_id: to_status_id,
                transition_type: transition_type_name,
                transition_type_id: transition_type_id,
                action: action_name,
                min_approvals_required: Reflect.get(reviewer, 'min_approvals') || 1,
                is_active: true,
                condition: {
                    operator: Reflect.get(reviewer, 'match_requirement') === 'all' ? 'AND' : 'OR',
                    rules: conditions_payload
                }
            };
            return transition_rule;
        },

        build_transition_payload(transition_rule) {
            const payload = {
                form_id: parseInt(Reflect.get(this, 'form_id'), 10),
                form_workflow_id: Reflect.get(this, 'form_workflow_id'),
                transition_rules: [transition_rule]
            };
            return payload;
        },

        handle_transition_response(response, reviewer) {
            if (Reflect.get(Reflect.get(response, 'data'), 'status') === 'success') {
                this.show_success('Transition rule saved successfully!');

                const response_data = Reflect.get(Reflect.get(response, 'data'), 'data');
                if (response_data && response_data.length > 0 && response_data[0]) {
                    const created_rule = response_data[0];
                    Reflect.set(reviewer, 'id', Reflect.get(created_rule, 'id'));
                    if (Reflect.get(created_rule, 'workflow_reviewer_id')) {
                        Reflect.set(reviewer, 'workflow_reviewer_id', Reflect.get(created_rule, 'workflow_reviewer_id'));
                    }
                }

                Reflect.set(reviewer, 'show_condition_ui', false);
            } else {
                this.show_error('Failed to save transition rule');
            }
        },

        handle_transition_error(error) {
            if (Reflect.get(error, 'response') && Reflect.get(error, 'response').data) {
                const error_data = Reflect.get(error, 'response').data;
                const error_message = Reflect.get(error_data, 'message') ||
                    JSON.stringify(Reflect.get(error_data, 'errors')) ||
                    'Unknown server error';
                this.show_error('Error saving transition rule: ' + error_message);
            } else if (Reflect.get(error, 'request')) {
                this.show_error('Network error: Could not connect to server');
            } else {
                this.show_error('Error saving transition rule: ' + error.message);
            }
        },

        remove_transition_rule(status_index, reviewer_index) {
            const workflow_statuses = Reflect.get(this, 'workflow_statuses');
            const status = Reflect.get(workflow_statuses, status_index);
            const reviewers = Reflect.get(status, 'reviewers');
            if (reviewers && reviewers.length > reviewer_index) {
                reviewers.splice(reviewer_index, 1);
                Reflect.set(status, 'reviewer_count', reviewers.length);
            }
        },

        get_status_name(status_id) {
            if (!status_id) return 'Unknown Status';
            const workflow_statuses = Reflect.get(this, 'workflow_statuses');
            const status = workflow_statuses.find(s => Reflect.get(s, 'id') === parseInt(status_id, 10));
            return status ? Reflect.get(status, 'status') : 'Unknown Status';
        },

        validate_status_selection(reviewer) {
            if (!Reflect.get(reviewer, 'to_status_id')) {
                this.show_error('Please select a target status');
            }
        },

        async get_transition_rules(status) {
            const payload = {
                form_id: parseInt(Reflect.get(this, 'form_id'), 10),
                from_status_id: parseInt(Reflect.get(status, 'id'), 10)
            };

            try {
                const response = await axios.post(
                    GET_FORM_WORKFLOW_TRANSITION_RULES,
                    payload,
                    { headers: Reflect.get(this, 'headers') }
                );

                if (Reflect.get(Reflect.get(response, 'data'), 'status') === 'success') {
                    const transition_rules = Reflect.get(Reflect.get(response, 'data'), 'data');
                    Reflect.set(status, 'existing_transition_rules', transition_rules);
                    this.populate_existing_transition_rules(status, transition_rules);
                    return transition_rules;
                } else {
                    this.show_error('Failed to load transition rules');
                    const empty_array = [];
                    return empty_array;
                }
            } catch (error) {
                this.show_error('Error fetching transition rules: ' + error.message);
                const empty_array = [];
                return empty_array;
            }
        },

        populate_existing_transition_rules(status, transition_rules) {
            if (!transition_rules || transition_rules.length === 0) {
                return;
            }

            Reflect.set(status, 'reviewers', []);
            Reflect.set(status, 'reviewer_count', transition_rules.length);

            transition_rules.forEach((rule) => {
                const reviewer = this.initialize_reviewer();

                Reflect.set(reviewer, 'id', Reflect.get(rule, 'id'));
                Reflect.set(reviewer, 'to_status_id', Reflect.get(Reflect.get(rule, 'to_status'), 'id').toString());
                Reflect.set(reviewer, 'transition_type_id', Reflect.get(Reflect.get(rule, 'transition_type'), 'id'));
                Reflect.set(reviewer, 'min_approvals', Reflect.get(rule, 'min_approvals'));

                const condition_operator = Reflect.get(Reflect.get(rule, 'condition'), 'operator');
                Reflect.set(reviewer, 'match_requirement', condition_operator ? condition_operator.toLowerCase() : 'all');

                const condition_rules = Reflect.get(Reflect.get(rule, 'condition'), 'rules');
                if (condition_rules && condition_rules.length > 0) {
                    const conditions = condition_rules.map(condition => {
                        let selected_action_value = [];

                        if (Reflect.get(condition, 'selected_actions') && Array.isArray(Reflect.get(condition, 'selected_actions'))) {
                            selected_action_value = Reflect.get(condition, 'selected_actions');
                        } else if (Reflect.get(condition, 'selected_action')) {
                            const single_val = Reflect.get(condition, 'selected_action');
                            selected_action_value = Array.isArray(single_val) ? single_val : [single_val];
                        }

                        const mapped_condition = {
                            action_type: Reflect.get(condition, 'action_type') || '',
                            selected_action: selected_action_value,
                            action_search: '',
                            section_scope: Reflect.get(condition, 'section_scope') || 'all',
                            selected_sections: Reflect.get(condition, 'selected_sections') || [],
                            question_scope: Reflect.get(condition, 'question_scope') || 'all',
                            selected_sections_for_questions: Reflect.get(condition, 'selected_sections_for_questions') || [],
                            selected_questions: Reflect.get(condition, 'selected_questions') || [],
                            required_role: Reflect.get(condition, 'required_role') || '',
                            completion_type: Reflect.get(condition, 'completion_type') || 'complete',
                            approvals_required: Reflect.get(condition, 'approvals_required') || 1
                        };

                        return mapped_condition;
                    });
                    Reflect.set(reviewer, 'conditions', conditions);
                }

                if (Reflect.get(rule, 'workflow_reviewer_id')) {
                    Reflect.set(reviewer, 'workflow_reviewer_id', Reflect.get(rule, 'workflow_reviewer_id'));
                }

                Reflect.get(status, 'reviewers').push(reviewer);
            });
        }
    }
};